<script>
  // const appui = "/assets_default/images/business/top/appui.webp";
  const Qicon = "/assets_default/icons/text_q.svg"
  const Aicon = "/assets_default/icons/text_a.svg"
  const Chevron = "/assets_default/icons/chevron_down.svg"
</script>

<section class="owd-biz-section:max:1200 faq-section" id="faq">
  <section-head biz="true" title="よくある質問" caption="FAQ"></section-head>
  <div class="owd-biz-inner:contents">
    <div class="owd-accordion owd-accordion:qa">
      <details class="owd-accordion-item" id="">
        <summary class="owd-accordion-item-head:qa">
          <img src="{Qicon}" alt="Q文字アイコン">
          <p class="owd-text:02 custom-display"><strong>利用できるサービスを教えてください</strong></p>
          <img class="owd-accordion-item-head-chevron" src="{Chevron}" alt="下矢印アイコン">
        </summary>
        <div class="owd-accordion-item-body:qa">
          <img src="{Aicon}" alt="A文字アイコン">
          <div class="owd-accordion-item-body-textarea">
            <p class="owd-text:02 spacing:bottom:12">
              法人口座開設後、法人インターネットバンキングにて、以下サービスをご利用いただけます。
              <br>＜振込＞
              <br>振込・予約振込： 自行・他行宛の振込
              <br>振込先管理： よく使う振込先の登録・管理
            </p>
            <ul class="owd-list:annotation">
              <li>総合振込、給与振込には対応していません。</li>
            </ul>
            <p class="owd-text:02">
              <br>＜残高・取引明細の照会＞
              <br>入出金明細： 照会期間の指定、PDF・CSV出力
              <br>残高照会：残高の確認、残高証明書（PDF）の発行
              <br>状況確認： 振込結果、予約振込の確認・取消、承認依頼の進捗確認
            </p>
          </div>
        </div>
      </details>
      <details class="owd-accordion-item" id="">
        <summary class="owd-accordion-item-head:qa">
          <img src="{Qicon}" alt="Q文字アイコン">
          <p class="owd-text:02 custom-display"><strong>法人口座を開設できる法人の種類を教えてください</strong></p>
          <img class="owd-accordion-item-head-chevron" src="{Chevron}" alt="下矢印アイコン">
        </summary>
        <div class="owd-accordion-item-body:qa">
          <img src="{Aicon}" alt="A文字アイコン">
          <div class="owd-accordion-item-body-textarea">
            <p class="owd-text:02 spacing:bottom:12">
              当行で口座開設できる方は、営利法人（株式会社、特例有限会社、合同会社、合名会社、合資会社）に限ります。現在、個人事業主は開設できません。
            </p>
            <ul class="owd-list:annotation">
              <li>口座開設のお手続き時に当行所定の審査がございます。</li>
            </ul>
          </div>
        </div>
      </details>
      <details class="owd-accordion-item" id="">
        <summary class="owd-accordion-item-head:qa">
          <img src="{Qicon}" alt="Q文字アイコン">
          <p class="owd-text:02 custom-display"><strong>法人口座開設に必要な書類を教えてください</strong></p>
          <img class="owd-accordion-item-head-chevron" src="{Chevron}" alt="下矢印アイコン">
        </summary>
        <div class="owd-accordion-item-body:qa">
          <img src="{Aicon}" alt="A文字アイコン">
          <div class="owd-accordion-item-body-textarea">
            <p class="owd-text:02 spacing:bottom:12">事業内容を確認できる書類が必要です。申込み手続きを行ってください。
              <br>■以下①～⑦から2点以上、ただし、①～④の中から必ず1点以上
              <br>①主たる事務所の建物賃貸借契約書
              <br>②取引先との押印済契約書
              <br>③他社発行の請求書、発注書、受注書、納品書のいずれか1点（※文房具など備品は対象外です）
              <br>④国税または地方税の領収書、または納税証明書
              <br>⑤許認可証
              <br>⑥会社案内、パンフレット、提案資料、商品企画書、事業計画書 のいずれか1点
              <br>⑦自社発行の請求書、発注書、受注書、納品書のいずれか1点
              <br><br>■代表者のマイナンバーカード
              <br>署名用電子証明書パスワードの入力が必要です。</p>
            <ul class="owd-list:annotation">
              <li>その他、追加で書類の提出をお願いすることがあります。</li>
            </ul>
          </div>
        </div>
      </details>
    </div>
    <button-biz url="https://cs-faq.minna-no-ginko.com/category/show/82" title="他のよくある質問を見る" type="secondary:white" blank single></button-biz>
  </div>
</section>

<style lang="scss">
.faq-section{
  margin-bottom: 240px;
  @include g.mobile () {
    margin-bottom: 80px;
  }
}
.custom-display {
  display: flex;
}
.owd-accordion{
  margin-bottom: 48px;
  @include g.mobile () {
    margin-bottom: 32px;
  }
}
</style>
